<template>
  <svg viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M33.0759 29.2626C30.8663 30.3869 29.8611 32.5163 29.8611 34.9021V43.6518C29.8611 44.2917 29.8972 44.8915 29.9793 45.4505H7.01434C4.41368 45.4505 2.85815 44.2352 2.85815 42.2178C2.85815 35.9472 10.7087 27.2947 23.2988 27.2947C26.9982 27.2947 30.2879 28.0389 33.0759 29.2626ZM33.045 12.2012C33.045 18.2774 28.5243 22.944 23.3229 22.944C18.0973 22.944 13.601 18.2774 13.601 12.2498C13.601 6.29504 18.1217 1.75 23.3229 1.75C28.5243 1.75 33.045 6.19782 33.045 12.2012Z"
      :fill="primaryColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M52.1729 32.0341C50.7391 31.451 46.2425 29.8467 44.8573 29.3606C44.0551 29.0933 43.1559 29.0933 42.2567 29.4579C41.8964 29.5903 41.2337 29.8249 40.4456 30.1039C38.6279 30.7475 36.1428 31.6274 35.1595 32.0341C33.7254 32.6419 33.1664 33.5655 33.1664 34.9752V43.7249C33.1664 48.3915 35.9129 50.0685 42.524 53.9573C43.1074 54.2978 44.031 54.3948 44.7843 53.9573C51.3952 50.0685 54.1419 48.3915 54.1419 43.7249V34.9752C54.1419 33.5655 53.607 32.6419 52.1729 32.0341ZM40.3479 39.8119V38.4835C40.3479 36.2399 41.6763 34.7344 43.6542 34.7344C45.6321 34.7344 46.9605 36.2399 46.9605 38.4835V39.8119C47.61 39.871 47.9347 40.2843 47.9347 41.0813V45.7751C47.9347 46.6312 47.5509 47.0445 46.7539 47.0445H40.5545C39.7575 47.0445 39.3737 46.6312 39.3737 45.7751V41.0813C39.3737 40.2843 39.6984 39.871 40.3479 39.8119ZM45.6026 39.8119V38.3359C45.6026 36.978 44.8646 36.0628 43.6837 36.0628C42.5029 36.0628 41.7354 36.978 41.7354 38.3359V39.8119H45.6026Z"
      :fill="secondaryColor"
    />
  </svg>
</template>
<script>
import AbstractIcon from '@/assets/icons/AbstractIcon.vue'

export default {
  extends: AbstractIcon,
}
</script>
